import {
	proposalList,
	proposalShow,
} from '@/services/tv/sponsorships.service'

export default {
	namespaced: true,
	state: {
		// PROPOSALS
		proposalList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		proposal: {},

		// STATUS
		proposalListStatus: 'pending',
		proposalShowStatus: 'init',
	},
	getters: {
		getProposalList(state) {
			return state.proposalList
		},
		getProposal(state) {
			return state.proposal
		},
		getProposalListStatus(state) {
			return state.proposalListStatus
		},
		getProposalShowStatus(state) {
			return state.proposalShowStatus
		},

		// Legacy getters for backward compatibility during transition
		getCampaignList(state) {
			return state.proposalList
		},
		getCampaignListStatus(state) {
			return state.proposalListStatus
		},
	},
	mutations: {
		PROPOSAL_LIST(state, value) {
			state.proposalList = value
		},
		SET_PROPOSAL(state, value) {
			state.proposal = value
		},
		PROPOSAL_LIST_STATUS(state, value) {
			state.proposalListStatus = value
		},
		PROPOSAL_SHOW_STATUS(state, value) {
			state.proposalShowStatus = value
		},
	},
	actions: {
		async fetchProposalList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('PROPOSAL_LIST_STATUS', 'pending')
			commit('PROPOSAL_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await proposalList(params)
				commit('PROPOSAL_LIST_STATUS', 'init')
				commit('PROPOSAL_LIST', data)
				return data
			} catch (error) {
				commit('PROPOSAL_LIST_STATUS', 'init')
				throw error
			}
		},
		async fetchProposalByID({ commit }, id) {
			commit('PROPOSAL_SHOW_STATUS', 'pending')
			try {
				const { data } = await proposalShow(id)
				commit('PROPOSAL_SHOW_STATUS', 'init')
				commit('SET_PROPOSAL', data.data)
				return data
			} catch (error) {
				commit('PROPOSAL_SHOW_STATUS', 'init')
				return error
			}
		},

		// Legacy aliases
		async fetchCampaignList({ dispatch }, params) {
			return dispatch('fetchProposalList', params)
		},
	},
}
